module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_course04-72795a60ee2402f264c1ae4767840018.png";